import { ListSkeleton, Numeric, SectionCard } from "@/shared/components";
import { useTopKeywords } from "./hooks";

export function TopKeywords() {
  const { data: keywords, isLoading } = useTopKeywords(7);

  return (
    <SectionCard title="인기 키워드">
      {isLoading ? (
        <ListSkeleton count={7} />
      ) : (
        <div className="space-y-2">
          {(keywords ?? []).map((kw, index) => (
            <div
              key={kw.keyword}
              className="flex items-center gap-3 rounded-sm bg-surface-sunken/30 px-3 py-2"
            >
              <span className="flex size-5 items-center justify-center rounded-full bg-surface-sunken text-[10px] font-bold text-text-tertiary">
                {index + 1}
              </span>
              <span className="flex-1 text-[12px] font-medium">
                {kw.keyword}
              </span>
              <Numeric className="text-right text-[11px] font-semibold">
                {kw.monthlySearchVolume.toLocaleString()}
              </Numeric>
            </div>
          ))}
          {(!keywords || keywords.length === 0) && (
            <p className="py-6 text-center text-[12px] text-text-tertiary">
              키워드 데이터가 없습니다.
            </p>
          )}
        </div>
      )}
    </SectionCard>
  );
}
